let inject = [
  '$scope',
  'BillfoldService',
  '$state',
  '$rootScope',
  'SharedService',
  '$timeout',
  'ngAuthSettings',
  'CartService',
  'SessionService',
  'NgTableParams',
  '$uibModal',
  '$filter',
  'Pagination',
];

class BillfoldController{
  constructor ($scope,
               BillfoldService,
               $state,
               $rootScope,
               SharedService,
               $timeout,
               ngAuthSettings,
               CartService,
               SessionService,
               NgTableParams,
               $uibModal,
               $filter,
               Pagination) {
    this.$state = $state;
    this.SessionService = SessionService;
    this.ngAuthSettings = ngAuthSettings;
    this.CartService = CartService;
    this.$filter = $filter;
    this.paginator = Pagination;
    // this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.NgTableParams = NgTableParams;
    this.BillfoldService = BillfoldService;
    this.$uibModal = $uibModal;
    this.SharedService = SharedService;
    this.billfolds = null;
    this.watchingBillfold = false;
    this.stateBillfold = {};
    this.billfoldSelected = null;
    // ngTable Params
    this.ngTableConfigBillfold = null;
    this.ngTableColsBillfold = null;
    this.state = {};
    this.updatedAt = '';
    this.branches = [];
    // ngTable Params
    this.ngTableConfig = null;
    this.ngTableCols = null;
    this.thirdSelected = null;
    this.branchesSelected = null;

    this.exportingData = false;
    this.exportCorrect = false;
    this.exportCorrectPdf = false;

    this.sort = null;
    this.searchText = '';
    this.sortType = 'documento';
    this.sortReverse = true;
    this.userOrders = [];
    this.summary = [];
    this.itemsPerPage = 20;
    this.loadingUserOrders = true;
    this.loadedUserOrders = false;
    this.errorloadingUserOrders = false;
    this.currentPage = 1;
    this.actualPage = 0;
    this.filters = {};
    this.filtersCopy = {};

    this.maxSize = 5;
    this.bigTotalItems = 0;
    this.bigCurrentPage = 1;
    this.totalItemsPage = 12;
    this.statictics = {};

    this.bigTotalItemsDetails = 0;
    this.bigCurrentPageDetail = 1;
    this.totalItemsPageDetail = 12;
    this.pagination = {};

    this.billfoldSelectedBase = {};
    this.data_add = {
      cupoCredito: 0,
      numeroDocumentosPendientes: 0,
      numeroDocumentosVencidos: 0,
      valorTotalDocumentosPendientes: 1000,
      valorTotalDocumentosVencidos: 0,
      cupoDisponible: 0
    };
  }

  $onInit(){
    if(!this.shCtrl.globals.currentClient) this.shCtrl.globals.currentClient = {};
    if(!this.shCtrl.globals.currentClient.third) return;
    if(!this.shCtrl.globals.currentClient.third.documentNumber) return;
    this.getBillFolds();
  }

  getBranches(item){
    this.thirdSelected = item;
    this.BillfoldService.getBranchesByThirdId(item.id).then(response => {
      this.branches = response;
    });
  }

  getBillFolds() {
    let documentNumber = '';

    documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;

    this.state = {};
    this.state.loading = true;
    this.state.error = false;


    this.BillfoldService.getBillFoldsByClient(documentNumber)
      .then(billfolds => {
        this.state.loading = false;
        this.state.loaded = true;

        if(billfolds === 'null'){
          this.billfolds = [];
        }else{
          this.billfolds = billfolds.data.CXC;
          this.data_add = billfolds.data.adicional;
          this.bigTotalItems = billfolds.data.CXC.length;
          this.pagination = this.paginator.getNew(this.totalItemsPage);
          this.pagination.numPages = Math.ceil(this.bigTotalItems / this.pagination.perPage);
          this.totalItemsPage = this.bigTotalItems;
          this.initNgTable();
          
        }
      })
      .catch(error => {
        this.state.loading = false;
        this.state.error = true;
      });
    
  }



  initNgTable() {

    /**
     * docuemtno
     * fecha_emision
     * fecha_vencimiento
     * dias_vencido
     * fecha_prontopago
     * dias_vencido
     * valor_prontopago
     * valor_documento
     * valor_pendiente
     */

    this.ngTableCols = [
      {
        field: "documento",
        title: "Documento",
        sortable: "documento",
        filter: { "documento": "text" },
        show: true
      },
      {
        field: "fecha_emision",
        title: "Fecha Emisión",
        sortable: "fecha_emision",
        filter: { "fecha_emision": "text" },
        show: true
      },
      {
        field: "fecha_vencimiento",
        title: "Fecha Vencimiento",
        sortable: "fecha_vencimiento",
        filter: { "fecha_vencimiento": "text" },
        show: true
      },
      {
        field: "dias_vencido",
        title: "Días De Vencido",
        sortable: "dias_vencido",
        filter: { "dias_vencido": "number" },
        show: true
      },
      {
        field: "fecha_prontopago",
        title: "Fecha Prontopago",
        sortable: "fecha_prontopago",
        filter: { "fecha_prontopago": "text" },
        show: true
      },
      {
        field: "valor_prontopago",
        title: "Valor Prontopago",
        sortable: "valor_prontopago",
        filter: { "valor_prontopago": "number" },
        show: true
      },
      {
        field: "valor_documento",
        title: "Valor Documento",
        sortable: "valor_documento",
        filter: { "valor_documento": "number" },
        show: true
      },
      {
        field: "valor_pendiente",
        title: "Valor Pendiente",
        sortable: "valor_pendiente",
        filter: { "valor_pendiente": "number" },
        show: true
      }
    ];

    let initialParams = {
      count: 20
    };

    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.billfolds
    };

    this.ngTableConfig = new this.NgTableParams(initialParams, initialSettings);
  }

  exportExcel(){

    this.exportingData = true;
    let nameClient = this.shCtrl.globals.currentClient.third.name;
    let documentNumber = '';
    documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
    //console.log(this.orders);
    this.BillfoldService.getExportExcel(this.billfolds,nameClient,documentNumber)
        .then((datos) => {
          console.log(datos.data.url_excel);
          open(datos.data.url_excel);
          this.exportingData = false;
          this.exportCorrect = true;

        }).catch((error) => {
      this.exportingData = false;
      this.exportCorrect = false;
      this.state.error = true;

    });
  }

  exportPdf(){

    this.exportingData = true;
    let nameClient = this.shCtrl.globals.currentClient.third.name;
    let date = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
    let documentNumber = '';
    documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
    let thirdOwner = '';
    thirdOwner = this.shCtrl.ngAuthSettings.site.info.company.name;
    //console.log(this.orders);
    this.BillfoldService.getExportPdf(this.billfolds,nameClient,documentNumber)
        .then((responsepdf) => {
            
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(responsepdf);
            link.download = `${thirdOwner}_${documentNumber}_FacturasPendientes_${date}.pdf`;
            link.target = '_blank';
            link.click();

            this.exportCorrectPdf = true;
            this.exportingData = false;
        }).catch((error) => {
      this.exportingData = false;
      this.exportCorrectPdf = false;
      this.state.error = true;

    });
  }

  showSort(value) {
    this.sort = value;
  }
}

BillfoldController.$inject = inject;

export default BillfoldController;




/** WEBPACK FOOTER **
 ** ./www/components/reports/billfold/billfold.controller.js
 **/